import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function GTMRouteListener() {
  const location = useLocation();

  useEffect(() => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'pageview',
        page: location.pathname,
      });
    }
  }, [location]);

  return null;
}
